module.exports = __webpack_public_path__ + "img/pc-bg.007cdbd3.png";